module.exports = __webpack_public_path__ + "static/media/ua.5196d8ea.svg";